<template>
<div>
    <button v-show="button" v-on:click="open()" class="btn btn-primary">Add Break</button>
    <div class="holiday-breaks-input">
		<div name="holiday-breaks-input--calendar">
			<div v-show="editing" v-bind:class="editing ? 'opened' : ''">
                <GenericModal
                    ref="add_holiday"
                    :title="entryId != null ? 'Edit break' : 'Add break'"
                    :hideButton="true"
                    >
                    <div class="inner-content">

                        <input ref="flatpickr" hidden="hidden"/>

                        <div class="holiday-breaks-input--calendar-inner-footer">
                            <label class="checkbox my-2 d-inline-flex" for="entry_repeats" v-on="!button ? {click: toggleEntryRepeats} : {}">
                                <input type="checkbox" v-model="entryRepeats" id="entry_repeats">
                                <div class="checkbox--check"></div>
                                <span class="ml-2">Repeats annually</span>
                            </label>

                            <label v-if="copy_jobs && !entryId" class="checkbox my-2 d-inline-flex" for="copy_jobs" v-on="!button ? {click: toggleExistingJobs} : {}">
                                <input type="checkbox" v-model="entryExistingJobs" id="copy_jobs">
                                <div class="checkbox--check" ></div>
                                <span class="ml-2">Apply to existing jobs</span>
                            </label>

                            <button
                                class="work-days-input--header-button btn btn-danger"
                                v-bind:disabled="saving"
                                v-show="entryId"
                                v-on:click="remove()"
                            >
                                <loader class="loaders--small loaders--light" v-if="saving"></loader>
                                <span v-else>{{ 'Delete' }}</span>
                            </button>

                            <button
                                class="work-days-input--header-button btn btn-primary"
                                v-bind:class="copy_jobs && !entryId ? 'w-100' : ''"
                                v-bind:disabled="saving"
                                v-on:click="entryId ? update() : save()"
                            >
                                <loader class="loaders--small loaders--light" v-if="saving"></loader>
                                <span v-else>{{ entryId ? 'Update' : 'Add' }}</span>
                            </button>
                        </div>
                    </div>
                </GenericModal>
			</div>
		</div>
    </div>
</div>
</template>

<script>
	import flatpickr from "flatpickr";
	import Loader from "../general_components/Loader";
    import GenericModal from '../modals/GenericModal.vue';

	export default {
		name: "FlatpickrCalendar",
		components: {Loader, GenericModal},
		props: {
			create_url: {
				type: String,
				required: true
			},
			update_url: {
				type: String,
				required: true
			},
			destroy_url: {
				type: String,
				required: true
			},

			copy_jobs: {
				type: Boolean,
				default: false
			},

            button: {
                type: Boolean,
                default: false
            },

            refresh_on_new_data: {
                type: Boolean,
                default: true,
            }
		},

		data(){
            return {
				flatpickrInstance: null,

				entryId: null,
				entryRepeats: false,
				entryExistingJobs: false,

                startDate: Date.now().toString(),
                endDate: Date.now().toString(),

				editing: false,
				saving: false,
			}
		},

		mounted() {
			document.addEventListener('click', this.clicked);
            this.flatpickrInstance = flatpickr(this.$refs.flatpickr, {
                inline: true,
                mode: 'range',
                defaultDate: [this.startDate, this.endDate],
                onReady (_, __, fp) {
                    fp.calendarContainer.classList.add("calendar");
                },
                onChange: function(selectedDates) {
                    this.startDate = Date(selectedDates[0].toISOString());
                    this.endDate = selectedDates[1]==null ? this.startDate : Date(selectedDates[1].toISOString());
                },
            });
		},

		methods: {
			save(){
				if (this.saving) return;

				if (!this.flatpickrInstance.selectedDates[0]){
					Vue.$toast.open({
                        message: 'Please select a date',
                        type: 'error'
                    });
					return;
				}

				this.saving = true;
				const start_date = this.flatpickrInstance.selectedDates[0];
				const end_date = this.flatpickrInstance.selectedDates[1] || this.flatpickrInstance.selectedDates[0];

				let data = {
					start_date: flatpickr.formatDate(start_date, 'Y-m-d'),
					end_date: flatpickr.formatDate(end_date, 'Y-m-d'),
					repeats: !!this.entryRepeats
				}

				if (this.copy_jobs) data.existing_jobs = this.entryExistingJobs;

				axios.post(this.create_url, data)
					.then(response => {
						this.$emit('add-break', response.data);
						this.saving = false;

						//hide the modal
						this.clicked(null, true);

						Vue.$toast.open({
                            message: 'Added break',
                            type: 'success'
                        });

                       this.refresh();
					})
					.catch(error => {
                        console.log(error);
						Vue.$toast.open({
                            message: 'Something went wrong.\nPlease refresh your page and try again',
                            type: 'error'
                        });
						this.saving = false;
					})
			},

			update(){
				if (this.saving) return;

				this.saving = true;

				const start_date = this.flatpickrInstance.selectedDates[0];
				const end_date = this.flatpickrInstance.selectedDates[1] || this.flatpickrInstance.selectedDates[0];

				let data = {
					start_date: flatpickr.formatDate(start_date, 'Y-m-d'),
					end_date: flatpickr.formatDate(end_date, 'Y-m-d'),
					repeats: !!this.entryRepeats
				};

				if (this.copy_jobs)
					data.existing_jobs = !!confirm('Do you want to apply the changes to existing jobs?');

				axios.patch(this.update_url.replace('?', this.entryId), data)
					.then(response => {
						this.$emit('update-break', response.data);
						this.saving = false;

						//hide the modal
						this.clicked(null, true);
					})
					.catch(error => {
                        console.log(error);
						Vue.$toast.open({
                            message: 'Something went wrong.\nPlease refresh your page and try again',
                            type: 'error'
                        });
						this.saving = false;
					})
			},

			remove(){
				if (this.saving) return;

				if (!confirm('Are you sure you want to remove this break?'))
					return;

				if (this.copy_jobs)
					this.entryExistingJobs = !!confirm('Do you want to remove the same dates on existing jobs?');

				this.saving = true;

				//compile the url to include the existing_jobs query
				const url = this.destroy_url.replace('?', this.entryId) +
					(this.copy_jobs ?  '?existing_jobs=' + this.entryExistingJobs : '');

				axios.delete(url)
					.then(response => {
						this.saving = false;
						//hide the modal
						this.clicked(null, true);
						this.$emit('remove-break', this.entryId);
					})
					.catch(error => {
                        console.log(error)
						Vue.$toast.open({
                            message: 'Something went wrong.\nPlease refresh your page and try again',
                            type: 'error'
                        });
					})
			},

			clicked(event, forced = false){
                // don't close the modal if the form is saving
				if (this.saving) return;

                // check the modal is being forced to be hidden by another method
				if (forced){
                    this.editing = false;
                    this.$refs.add_holiday.close();
					return;
				}
			},

            setEventInfo(entryId, entryRepeats, entryExistingJobs){
                console.log(entryId, entryRepeats, entryExistingJobs);
				this.entryId = entryId;
				this.entryRepeats = entryRepeats;
				this.entryExistingJobs = entryExistingJobs;
            },

            setFlatpickrDates(startDate = this.startDate, endDate = this.endDate){
                // Update the global active date range
                this.startDate = startDate;
                this.endDate = endDate;

                // Set the date range for flatpickr
                this.flatpickrInstance.selectedDates[0] = this.startDate;
                this.flatpickrInstance.selectedDates[1] = this.endDate;

                // Jump to start date and render flatpickr
                this.flatpickrInstance.jumpToDate(this.startDate);
                this.flatpickrInstance.redraw();

                // Show the modal
                this.editing = true;
                this.$refs.add_holiday.open();
            },

            resetValues(){
				this.entryId = null;
				this.entryRepeats = false;
				this.entryExistingJobs = false;

                this.startDate = new Date();
                this.endDate = new Date();

				this.editing = false;
				this.saving = false;
                console.log('reset values');
            },

            open(){
                this.resetValues();
                this.updateFlatpickrDates();
            },

            updateFlatpickrDates(startDate = this.start_date, endDate = this.end_date){
                // Update the global active date range
                this.start_date = startDate;
                this.end_date = endDate;

                // Show the modal
                this.editing = true;

                if(this.entry_id!=null){
                    this.setEventInfo(this.entry_id, this.entry_repeats, this.entry_existing_jobs);
                }else{
                    this.resetValues();
                }
                this.setFlatpickrDates(this.start_date, this.end_date);
            },

            toggleEntryRepeats(){
                console.log('toggled repeats');
                this.entryRepeats = !this.entryRepeats;
                // this.entryRepeats = false;
                console.log(this.entryRepeats);
            },

            toggleExistingJobs(){
                console.log('toggled exisiting');
                this.entryExistingJobs = !this.entryExistingJobs;
                // this.entryExistingJobs = false;
                console.log(this.entryExistingJobs);
            },

            // Refresh the page to update the data on the page when the calendar is not the child of the main calendar
            refresh() {
                if(this.refresh_on_new_data){
                    location.reload();
                }
            }
		},
	}
</script>

